import {mapNullToUndefined} from '../../../utils/mapperHelper.utils';
import {AddressWithContactFragment, SelectedCarrierServiceOptionFragment} from '../../../../gql/graphql';
import {AddressModel} from './Address.model';
import {ContactModel} from './Contact.model';
import {AddressWithContactModel} from './AddressWithContact.model';
import {DeliveryMethodModel} from './DeliveryMethod.model';
import {CustomerInfo, DeliveryInfo} from '@wix/auto_sdk_ecom_cart-v-2';

export class DeliveryInfoModel extends AddressWithContactModel {
  public method?: DeliveryMethodModel;

  constructor(params: DeliveryInfoModel) {
    super(params);
    this.method = params.method;
  }

  public static fromCheckoutV1(
    shippingDestination?: AddressWithContactFragment | null,
    selectedCarrierServiceOption?: SelectedCarrierServiceOptionFragment | null
  ) {
    return new DeliveryInfoModel({
      address: AddressModel.fromCheckoutV1(shippingDestination?.address),
      contact: ContactModel.fromCheckoutV1(shippingDestination?.contactDetails),
      addressId: mapNullToUndefined(shippingDestination?.addressesServiceId),
      method: DeliveryMethodModel.fromCheckoutV1(selectedCarrierServiceOption),
    });
  }

  public static fromCartV2(deliveryInfo: DeliveryInfo, customerInfo: CustomerInfo): DeliveryInfoModel {
    return new DeliveryInfoModel({
      address: AddressModel.fromCartV2(deliveryInfo.address),
      contact: ContactModel.fromCartV2({
        firstName: customerInfo?.firstName,
        lastName: customerInfo?.lastName,
        phone: customerInfo?.phone,
        company: customerInfo?.company,
        vatId: customerInfo?.vatId,
      }),
      addressId: mapNullToUndefined((deliveryInfo as unknown as {addressId?: string}).addressId),
      method: DeliveryMethodModel.fromCartV2(deliveryInfo.method),
    });
  }
}
